import React from "react";
import "../Cards/Cards.css";
import { themeContext } from "../../Context";
import { useContext } from "react";

export const Cards = ({ emoji, heading, detail }) => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div
      className="card-component"
      style={{
        boxShadow: darkMode ? "0 0 10px white" : "none",
      }}
    >
      <img src={emoji} alt="" />
      <span style={{ color: darkMode ? "orange" : "" }}>{heading}</span>
      <span style={{ color: darkMode ? "white" : "" }}>{detail}</span>
    </div>
  );
};
